import React, { Component } from 'react';
import { Loader } from '../../utils/common';
import { Row, Col, Modal, Button, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form , Alert } from "reactstrap";
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';
import Constants from '../../config/constants';
import DatePicker from 'react-date-picker';
import { createCouponCode } from '../../utils/common';

import * as _ from 'underscore'



class AddAffiliatedDiscount extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      couponCode : createCouponCode(),
      discount : "30",
      lifetimeDiscount : "0",
      monthlyDiscount : "0",
      yearlyDiscount : "0",
      commission : "",
      discountType : Constants.PERCENTAGE,
      maxDiscount : Constants.MAX_DISCOUNT_PERCRNTAGE,
      description : "",
      email : "",
      firstName : "",
      lastName : "",
      activeTab : this.props.activeTab,
      startOn : new Date(moment().format("YYYY-MM-DD")),
      expiredOn : new Date(moment().add(1, 'year').format("YYYY-MM-DD")),
      currentDate : new Date(moment().format("YYYY-MM-DD")),
    }
  }

  componentDidMount() {
    this.setDifferences(this.state.discount)
  }

  componentWillReceiveProps(nextProps) {
    //let self = this;
    Loader(nextProps.requestProcess);
  }


  setDifferences(discount) {
    let discountDifference = _.findWhere(this.props.appstoreDifferences, {couponSlug: "PERCENTAGE_"+discount});
    if (!_.isEmpty(discountDifference)) {
      this.setState({
        lifetimeDiscount : discountDifference.storeDiffLifetime,
        monthlyDiscount : discountDifference.storeDiffMonthly,
        yearlyDiscount : discountDifference.storeDiffYearly,
      })
    }
  }

  handleChange(event) {
    let target = event.target;
    let name = target.name;
    let value;


    if (name === "couponCode") {
      if (!(/^\S*$/.test(target.value))) {
        return false;
      }
      target.value = target.value.toUpperCase();
    }

    if (name === "startOn") {
      this.setState({expiredOn : target.value});
    }

    if (target.name === 'discountType') {
      this.state.maxDiscount = (target.value === Constants.PERCENTAGE) ? Constants.MAX_DISCOUNT_PERCRNTAGE : Constants.MAX_DISCOUNT_OFF;
      this.state.discount = 1;
    }

    if (name === "discount") {
      target.value = (target.value > this.state.maxDiscount) ? this.state.maxDiscount : target.value;
      if (this.props.appstoreDifferences && this.props.appstoreDifferences.length) {
        this.setDifferences(target.value)
      }
    }


    if (name === "commission") {
      target.value = (target.value < 0) ? 1 : (target.value >= 100 ) ? 100 : target.value;
    }

    value = target.value;
    this.setState({[name]: value});
  }

  handleSubmit(e) {
    if( this.validator.allValid()/* && this.state.totalPercentageError === ""*/){
      let discountsObj = {
        couponCode : this.state.couponCode,
        discount : this.state.discount,
        monthlyDiscount : this.state.monthlyDiscount,
        yearlyDiscount : this.state.yearlyDiscount,
        lifetimeDiscount : this.state.lifetimeDiscount,
        type : this.state.discountType,
        description : this.state.description,
        email : this.state.email,
        discountType : this.state.activeTab,
        expiredOn : this.state.expiredOn,
        startOn : this.state.startOn,
        firstName : this.state.firstName,
        lastName : this.state.lastName,
        commission : this.state.commission,
        totalPercentageError : "",
        totalDiscountPercentage : ""
      }
      this.props._addDiscount(discountsObj);
    }else{
      this.validator.showMessages();
      this.forceUpdate();
    }
    e.preventDefault();
  }


formatTitlePosLabel (s) {
    if (typeof s !== 'string') return ''
      s = s.replace("_", " ");
      s = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
      return s;
  }


  setDate(name, value) {
    this.setState({[name] : new Date(value)})
  }


  render() {
    //let self = this;
    let { openAddAffiliatedDiscountModal, closeModal, addAffiliatedDiscountPopupError } = this.props;
    let { totalPercentageError } = this.state;

    return (
      <Modal isOpen={openAddAffiliatedDiscountModal}>
          <ModalHeader toggle={()=>{closeModal(false)}}>Add Affiliated Coupon</ModalHeader>
          <Form onSubmit={(event) => {this.handleSubmit(event)}}>
            <ModalBody>
              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="couponCode">Coupon Code</Label>
                      <Input type="text" maxLength="100" id="couponCode" placeholder="Coupon code" name="couponCode" value={this.state.couponCode} onChange={(event)=>{this.handleChange(event)}} min="5" pattern="^\S*$" />
                      <div className="validation-error">{ this.validator.message('Coupon code', this.state.couponCode, 'required|min:5') }</div>
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="discount">Discount value (%)</Label>

                      <Input type="select" id="discount" placeholder="Discount value" name="discount" value={this.state.discount} onChange={(event)=>{this.handleChange(event)}}>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </Input>
                      <div className="validation-error">{ this.validator.message('Discount', this.state.discount, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="monthlyDiscount">Monthly Discount ($)</Label>

                      <Input type="text" id="monthlyDiscount" placeholder="Monthly Discount" name="monthlyDiscount" value={this.state.monthlyDiscount} onChange={(event)=>{this.handleChange(event)}} step="any" readOnly>
                      </Input>
                      <div className="validation-error">{ this.validator.message('Monthly Discount', this.state.monthlyDiscount, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="yearlyDiscount">Yearly Discount ($)</Label>

                      <Input type="text" id="yearlyDiscount" placeholder="Yearly Discount" name="yearlyDiscount" value={this.state.yearlyDiscount} onChange={(event)=>{this.handleChange(event)}} step="any" readOnly>
                      </Input>
                      <div className="validation-error">{ this.validator.message('Yearly Discount', this.state.yearlyDiscount, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="lifetimeDiscount">Lifetime Discount ($)</Label>

                      <Input type="text" id="lifetimeDiscount" placeholder="Lifetime Discount" name="lifetimeDiscount" value={this.state.lifetimeDiscount} onChange={(event)=>{this.handleChange(event)}} step="any" readOnly>
                      </Input>
                      <div className="validation-error">{ this.validator.message('Lifetime Discount', this.state.lifetimeDiscount, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="description">Expired On</Label>

                      <DatePicker value={this.state.expiredOn} onChange={(event)=>{this.setDate('expiredOn',event)}} minDate={this.state.startOn} />
                      <div className="validation-error">{ this.validator.message('Expire Date', this.state.expiredOn, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>




              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="description">Description</Label>
                      <Input type="textarea" id="description" maxLength="500" placeholder="Description" name="description" value={this.state.description} onChange={(event)=>{this.handleChange(event)}} />
                      <div className="validation-error">{ this.validator.message('Description', this.state.description, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="email">First Name</Label>
                      <Input type="text" id="firstName" placeholder="First Name" name="firstName" value={this.state.firstName} onChange={(event)=>{this.handleChange(event)}} />
                      <div className="validation-error">{ this.validator.message('First Name', this.state.firstName, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="email">Last Name</Label>
                      <Input type="text" id="lastName" placeholder="Last Name" name="lastName" value={this.state.lastName} onChange={(event)=>{this.handleChange(event)}} />
                      <div className="validation-error">{ this.validator.message('Last Name', this.state.lastName, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="email">Email</Label>
                      <Input type="text" id="email" placeholder="Email" name="email" value={this.state.email} onChange={(event)=>{this.handleChange(event)}} />
                      <div className="validation-error">{ this.validator.message('Email', this.state.email, 'required|email') }</div>
                    </FormGroup>
                </Col>
              </Row>




              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="commission">Commission (%)</Label>
                      <Input type="number" id="commission" placeholder="Commission" name="commission" value={this.state.commission} onChange={(event)=>{this.handleChange(event)}} />
                      <div className="validation-error">{ this.validator.message('commission', this.state.commission, 'required') }</div>
                    </FormGroup>
                </Col>
              </Row>

              {(addAffiliatedDiscountPopupError) ? <Alert color="danger">{addAffiliatedDiscountPopupError}</Alert> : null}
               {(totalPercentageError) ? <Alert color="danger">{totalPercentageError}</Alert> : null}
            </ModalBody>
            <ModalFooter className="justify-content-left">
              <Button type="submit" size="sm" color="primary" >Add</Button>{' '}
              <Button type="reset" size="sm" color="danger"  onClick={() => { closeModal() }}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>

    );
  }
}

export default AddAffiliatedDiscount;
